import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {getMyBookingsUrl} from 'modules/meta/selectors'

import {useRouterProvider} from '@vio/core/src/_web/router/context/RouterContext'
import {stringifyUrlObject} from '@vio/core/src/utils/url'
import {
  FROZEN_DEAL_PARAM,
  useFrozenDealToast
} from '@vio/shared/src/dealFreeze/hooks/useFrozenDealToast'

// FrozenDealToast component is used to show a toast message whenever there is a url param called frozenDeal=1 that indicates the user frozen a deal.
export const FrozenDealToast: React.FC = () => {
  const myBookingsUrl = useSelector(getMyBookingsUrl)
  const {getQueryParams, replace} = useRouterProvider()

  const params = getQueryParams()
  const {showFrozenDealToast, closeFrozenDealToast} = useFrozenDealToast({
    myBookingsUrl
  })

  const removeParamFromUrl = () => {
    delete params[FROZEN_DEAL_PARAM]
    replace({search: stringifyUrlObject(params)})
  }

  useEffect(() => {
    if (params[FROZEN_DEAL_PARAM]) {
      showFrozenDealToast()
      removeParamFromUrl()
    }

    return () => closeFrozenDealToast()
    // Do not add showFrozenDealToast, closeFrozenDealToast methods to the dependencies array. It can cause infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
